<template>
    <div class="reo-items">
        <span class="dots">
            <span v-for="(a, index) in 3" :key="index"></span>
        </span>
        <div class="content">
            <span class="triangle"></span>
            <div class="content-list">
                <router-link v-for="(option, index) in options" :key="index" :class="option.note ? 'has-note' : ''" :to="option.to">
                    {{ option.label }}
                    <span v-if="option.note" class="red"><br>{{ option.note }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    props: {

        options: Array

    }

};
</script>

<style scoped lang="less">
.reo-items{
    position: relative;
    display: inline-block;
    z-index: 4;
    &:hover .content {
        display: block;
    }
    .dots{
        cursor: pointer;
        line-height: 0.4rem;
        @media @mobile{
            line-height: 0.8rem;
        }
    }
    .dots span{
        display: inline-block;
        width: 0.05rem;
        height: 0.05rem;
        border-radius: 100%;
        background-color: @theme;
        margin-right: 0.03rem;
        @media @mobile{
            margin-right: 0.06rem;
        }
    }
    .triangle{
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0.1rem 0.1rem 0.1rem;
        border-color: transparent transparent #fff transparent;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -0.1rem;
        @media @mobile{
            left: unset;
            right: -0.06rem;
            border-width: 0 0.2rem 0.2rem 0.2rem;
            top: -0.19rem;
        }
    }
    .content{
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 3rem;
        display: none;
        @media @mobile{
            right: -0.1rem;
            left: unset;
            transform: none;
            width: 3.4rem;
            text-align: center;
        }
        .content-list{
            background-color: #fff;
            box-shadow: 0 2.85px 10px 4px rgba(0,0,0,.14);
            a{
                display: block;
                padding: 0.2rem 15px;
                font-size: 0.16rem;
                font-weight: 500;
                color: #555;
                @media @mobile{
                    font-size: 0.26rem;
                    padding: 0.33rem 15px;
                }
                &:hover{
                    color: @theme;
                    background-color: #FAFBFC;
                }
                &.has-note{
                    padding: 0.1rem 15px;
                    @media @mobile{
                        padding: 0.17rem 15px;
                    }
                }
                span{
                    font-size: 0.14rem;
                    @media @mobile{
                        font-size: 0.2rem;
                    }
                }
            }
            a+a{
                border-top: 1px solid #eee;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/basic/items.vue